export default "__VITE_ASSET__BfMh4zVw__"